<template>
  <el-dialog
    @close="close"
    ref="formDialog"
    :close-on-click-modal="false"
    :title="formTitle"
    :visible.sync="dialogFormVisible"
    :width="dialogWidth ? dialogWidth : '50%'"
  >
    <el-form :model="form" :rules="rules" ref="form" :class="{'multiple':multiple&&multiple>1}">
      <el-form-item
        :prop="d.key"
        :label-width="labelWidth||formLabelWidth"
        :key="d.name"
        :label="d.name"
        :style="`width:calc(100% / ${multiple?multiple:1});`"
        v-for="d in formData"
      >
        <el-input
          v-model="form[d.key]"
          autocomplete="off"
          :placeholder="d.placeholder||`请输入${d.name}`"
          v-if="d.type === 'input'"
          :readonly="d.disable"
          :disabled="d.disable"
          :maxlength="d.maxLength"
          :type="d.inputType ? d.inputType: 'text'"
          :show-word-limit="true"
          :max="d.max"
        >
      </el-input>
        <el-date-picker
          style="width: 100%;"
          v-if="d.type === 'date'"
          v-model="form[d.key]"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          :placeholder="d.placeholder||`请输入${d.name}`"
        >
        </el-date-picker>
        <el-cascader
          v-if="d.type === 'cascader'"
          v-model="form[d.key]"
          :options="d.option"
          :props="{ children: 'childList', label: 'defaultName', value: 'id' }"
          @change="cascaderChange($event, d.method)"
        >
        </el-cascader>
        <el-select
          v-model="form[d.key]"
          placeholder="请选择"
          v-if="d.type === 'select'"
          style="width: 100%"
          @change="changeSelect($event, d.method)"
        >
          <el-option
            :label="m.name"
            :key="m.key"
            :value="m.key"
            :disabled="m.disabled"
            v-for="m in d.option"
          ></el-option>
        </el-select>
        <el-select
          v-model="form[d.key]"
          placeholder="请选择"
          v-if="d.type === 'selectTree'"
          style="width: 100%"
        >
          <option-tree :treeData="d.option" :isShowAll="d.isShowAll"></option-tree>
        </el-select>
        <div v-if="d.type === 'radio'" style="text-align: left">
          <el-radio
            v-for="ms in d.radios"
            :key="ms.id"
            v-model="form[d.key]"
            :label="ms.id"
          >
            {{ ms[d.labelName] }}
          </el-radio>
        </div>
        <el-select
          v-model="form[d.key]"
          v-if="d.type === 'multiSelect'"
          style="width: calc(100% - 80px)"
          multiple
          placeholder="请选择"
        >
          <el-option
            :label="m.name"
            :key="m.key"
            :value="m.key"
            v-for="m in d.option"
          >
          </el-option>
        </el-select>
        <el-upload
          ref="upload"
          class="upload-demo"
          action=""
          :file-list="fileList"
          :auto-upload="false"
          multiple
          :limit="1"
          v-if="d.type === 'upload'"
        >
          <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
        <el-upload
          style="width: 50px !important; height: 50px !important"
          action="#"
          accept=".jpg,.jpeg,.png"
          list-type="picture-card"
          :auto-upload="false"
          :show-file-list="false"
          :on-change="handleFm"
          v-if="d.type === 'upload2'"
        >
          <img
            style="width: 50px; height: 50px"
            v-if="form[d.key]"
            :src="form[d.key]"
            class="avatar"
          />
          <i v-if="!form[d.key]" class="el-icon-plus"></i>
        </el-upload>
        <!--  el-switch-->
        <div style="display: flex;justify-content: flex-start;align-items: center;">
          <el-switch
            :name=d.name
            :key=d.key
            v-if="d.type === 'switch'"
            v-model="form[d.key]"
            :active-value="1"
            :inactive-value="0"
            style="margin-top: 7px;"
        >
        </el-switch>
        </div>
      </el-form-item>
    </el-form>
    <slot></slot>
    <div slot="footer" class="dialog-footer">
      <el-button class="el-button-cancel" @click="dialogFormVisible = false"
        >取 消</el-button
      >
      <el-button class="el-button-determine" type="primary" @click="formSubmit"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import OptionTree from './OptionTree.vue';
export default {
  name: "Dialog",
  components:{OptionTree},
  data() {
    return {
      formLabelWidth: "120px",
      form: {},
      formTitle: "",
      dialogFormVisible: false,
      obj: {},
      fileList: [],
    };
  },
  props: ["formData", "rules", "dialogWidth",'multiple','labelWidth'],
  methods: {
    close() {
      this.$refs.form.clearValidate();
    },
    formSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let submitData = this.formData;
          for (let i = 0; i < submitData.length; i++) {
            let ss = submitData[i].key;
            this.obj[ss] = this.form[ss];
          }
          this.$emit("formSubmit", this.obj);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleFm(file) {
      this.$emit('handleFm', file);
      this.$forceUpdate()
    },
    changeSelect(data, method) {
      method&&this.$emit(method, data);
    },
    cascaderChange(data, method) {
      method&&this.$emit(method, data);
    },
  },
  mounted() {
    this.formData.forEach(f => {
      this.$set(this.form, f.key,f.defaultData?f.defaultData:'' );
    })
  },

  created(){


  }

};
</script>

<style scoped lang="less">
@import "../../assets/css/globalDialog.less";
.el-button-determine {
  background-color: #356cfa;
  color: #ffffff;
  margin-left: 20px;
}
/deep/.el-upload{
  width: 50px;
  height: 50px;
  position: relative;
}
/deep/.el-icon-plus{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
.multiple{
  display: flex;
  flex-wrap: wrap;
}
</style>
